module.exports = __webpack_public_path__ + "img/4fd589c.png";